export default __webpack_public_path__ + "static/SR USA - Company Brochure-5c67919b9b9604f0dbae8da19f4e7386.pdf";